import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { VendorSearchService } from '../../../services/accounting/vendor-search.service';

@Component({
  selector: 'app-vendor-search',
  templateUrl: './vendor-search.component.html',
  styleUrls: ['./vendor-search.component.css'],
})
export class VendorSearchComponent implements OnInit, OnChanges {
  vendorSearchTerm: string;

  @Input() include_item: boolean = false;
  @Input() data: any = {};
  @Input() vendorId: number | undefined;
  @Input() small_input: boolean = false;
  @Input() editable: boolean = true;
  @Input() placeholder: string;
  @Output() vendor_id: EventEmitter<string> = new EventEmitter();
  @Input() select_only: boolean = false;
  @Input() triggerOnChange: boolean = false;
  @Output() vendor: EventEmitter<any> = new EventEmitter();
  @Output() clearVendor: EventEmitter<any> = new EventEmitter();

  constructor(private vendorSearchService: VendorSearchService) {}

  ngOnInit() {}

  ngOnChanges(changes: any) {
    if (changes.vendorId && changes.vendorId.currentValue && (!this.select_only || this.triggerOnChange))
      this.vendorSearchService.getVendorInfo(this.vendorId!).then((response_json) => {
        if (!this.select_only) this.vendorSearchTerm = response_json.name;
        if (this.triggerOnChange) {
          this.vendor.emit({
            id: this.vendorId,
            label: response_json.name,
            value: this.vendorId,
          });
          this.vendor_id.emit(String(this.vendorId));
        }
      });
    else if (this.select_only) this.vendorSearchTerm = '';
  }

  clearSelectedVendor(): void {
    this.vendorId = undefined;
    this.vendorSearchTerm = '';
    this.clearVendor.emit('clearVendor');
  }

  vendorSearchOnSelect(item: any): void {
    if (this.include_item) this.vendorId = item.id;
    else this.vendorId = item;
    if (this.select_only) {
      let scope = this;
      this.vendor.emit(item);
      window.setTimeout(function () {
        scope.vendorSearchTerm = '';
      }, 100);
    } else if (this.include_item) {
      this.vendor.emit(item);
      this.vendor_id.emit(String(item.id));
    } else this.vendor_id.emit(String(item));
  }
}
